import React from 'react';

type PoiCardPropType = {
  name: string;
  img: string;
  address: string;
  lat: string;
  lng: string;
  id: string;
  href: string;
  onPoiClick: (data: any) => void;
} & Partial<DefaultProps>;

interface PoiCardStateType {}

type DefaultProps = Readonly<typeof defaultProps>;

const defaultProps = {
  onPoiClick: (data: any) => {
    // empty
  },
};

export class PoiCard extends React.Component<
  PoiCardPropType,
  PoiCardStateType
> {
  static defaultProps: DefaultProps = defaultProps;

  state: PoiCardStateType = {};

  handlePoiClick: () => void = () => {
    const { onPoiClick, name, address, lat, lng, img, id, href } = this.props;
    // window.open(href);
    if (onPoiClick && typeof onPoiClick === 'function') {
      onPoiClick({
        name,
        address,
        lat,
        lng,
        img,
        id,
        href,
      });
    }
  };

  render() {
    const { name, address, lat, lng, img, id, href } = this.props;
    return (
      <div
        key={id}
        className="poi-card"
        onClick={this.handlePoiClick}
        data-name={name}
        data-address={address}
        data-img={img}
        data-lat={lat}
        data-lng={lng}
        data-id={id}
        data-href={href}>
        <div className="poi-card-img-wrapper">
          <img src={img} className="poi-card-img" />
        </div>
        <div className="poi-card-content">
          <div className="poi-card-content-name">{name}</div>
          <div className="poi-card-content-addr">{address}</div>
        </div>
      </div>
    );
  }
}
